import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { LogoWidget } from '@/pages/landing/components/logowidget/logowidget.component';

@Component({
    selector: '[app-footer]',
    standalone: true,
    imports: [LogoWidget],
    template: `
        <div class="layout-footer">
            <div class="footer-logo-container">
                <logo-widget [width]="40" [height]="40"></logo-widget>

            </div>
            <span class="footer-copyright">&#169; Ares - {{ currentYear }}</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
    currentYear = new Date().getFullYear();
}
